import { render, staticRenderFns } from "./RequestDuplicate.vue?vue&type=template&id=5bba1ac3"
import script from "./RequestDuplicate.vue?vue&type=script&lang=js"
export * from "./RequestDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports